<template>
    <div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :queryOnLoad="queryOnLoad" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" :btnColBaseCount="2" :btnColMoreTitle="'更多操作'" ref="result_table" :confKey="confKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="theTableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'

    import { getDefaultPageSizes } from '../../app.conf'
    import { checkUserActionPerm } from '../index'

    import finacApi from '../../api/finac'

    import SwbRefundVoucherDetail from './RefundVoucherDetail';
    Vue.regist(SwbRefundVoucherDetail);
    //
    import SwbTradeVoucherList from '../tradeVoucher/TradeVoucherList';
    Routes.add(SwbTradeVoucherList);

    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);
    import SwbRefundActRecList from './RefundActRecList';
    Vue.regist(SwbRefundActRecList);

    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);

    export default {
        name: 'swb-refund-voucher-of-vendor-list',
        path: '/refund/voucher/list/from/vendor',
        pathOld: '/refund/voucher/list-vendor',
        avlActions: 'to_trade_voucher|view_detail|confirm_recv_refund|audit|view_rec',
        avlActionNames: '查看详情、确认收款',
        avlScopes: 'retailer',
        desc: '供应商退款单据列表(退款给供应商)',
        helpArticleCode: 'retailer-refund-voucher-list-from-vendor',
        data: function () {
            return {
                confKey: "swb-refund-voucher-of-vendor-list",
                queryOnLoad: true,
                //
                theTableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                btnColName: 'actions',//操作列名称（如果不设置就不显示操作列）
                //
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 300,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                pageSize: getDefaultPageSizes().first(),
                pageNumber: 1,
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                //
                refundVoucherList: [],
                tradeNo: null,
                no: null,
                sellerName: null,
                fromDate: null,
                toDate: null,
                searchShow: false,
                //隐含的默认排序（最好不是显示列中字段，注意：不要设置el-table 的 default-sort属性）
                sortField: null,
                sortOrder: null
            }
        },
        created: function () {
            this.no = this.$route.query.no || null;
            // --------------------查询--------------------------------
            // this.getRefundVoucherList();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
            domSizeWatcher.setBaseEl(thisEl);
            domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                //根据新主元素的内容大小，调整表格高度
                self.theTableHeight = height;

            });
            //domSizeWatcher.setHrEls();
            domSizeWatcher.setVtEls(thisEl.find('[name="query-sort-block"]'));
            domSizeWatcher.start(500);
            //
            this.initResultTable();
            this.onConfigReady();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            initResultTable() {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[查询排序对象]到结果表格（结果表格可以实时利用最新的 列配置 和 排序信息，同时结果表格列宽也会反向同步到其中的[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'tradeNo': function (row, colName, colValue, rowIndex, btnName) {
                        if(self.checkActionPerm('to_trade_voucher') && !Utils.isNoB(row.tradeNo)) {
                            return '<a ref="#" class="table-cell-link">' + row.tradeNo + '</a>'
                        } else {
                            return Utils.isNoB(row.tradeNo) ? '' : row.tradeNo;
                        }
                    },
                    'amount': function (row, colName, colValue, rowIndex, btnName) {
                        let domHtml = '';
                        domHtml = domHtml + '<span>' + row.amount + '</span>';
                        if(row.orderNo != null && row.yjAmount > 0) {
                            domHtml = domHtml + '<span class="inline-block font-red">' + "(扣除手续费" + row.yjAmount + "元)" + '</span>';
                        }
                        return domHtml;
                    },
                    'actions': function (row, colName, colValue, rowIndex) {
                        let domHtml = '';
                        let btnList = [];
                        if(self.checkActionPerm('view_detail')) {
                            btnList.push({
                                name: 'view_detail',
                                text: '查看详情'
                            });
                        }
                        if(self.checkActionPerm('view_rec')) {
                            btnList.push({
                                name: 'view_rec',
                                text: '查看操作记录'
                            });
                        }
                        if(self.checkActionPerm('audit') && row.auditState == 0 && row.creatorMerchantType != row.buyerType) {
                            btnList.push({
                                name: 'audit',
                                text: '审核'
                            });
                        }
                        if(self.checkActionPerm('confirm_recv_refund') && row.payResult == 1 && !row.confirmState) {
                            btnList.push({
                                name: 'confirm_recv_refund',
                                text: '确认收款'
                            });
                        }
                        return btnList;
                    }
                }, /* 单元格按钮点击处理函数 */{
                    'tradeNo': function (row, colName, colValue, rowIndex, btnName) {
                        self.goToTradeVoucherList(row.tradeNo, row.contractOriginalNo)
                    },
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                        if(btnName == 'view_detail') {
                            self.refundVoucherDetail(row.id, 'chaKan');
                        } else if(btnName == 'view_rec') {
                            self.viewRefundActRecs(row.id);
                        } else if(btnName == 'audit') {
                            self.refundVoucherDetail(row.id, 'shenHe');
                        } else if(btnName == 'confirm_recv_refund') {
                            self.updateRefundVoucherConfirmState(row.id);
                        }
                    }
                });
            },
            renderTable(rows, pagination) {
                //
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };

                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            viewRefundActRecs: function (voucherId) {
                Vue.$showDialog({
                    title: "退款单据 - 操作记录",
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    width: 900,
                    height: 500,
                    template: '<div>' +
                    '<swb-refund-act-rec-list :voucherId="voucherId" ref="swb_refund_act-rec_list"></swb-refund-act-rec-list>' +
                    '</div>',
                    data: {
                        voucherId: voucherId
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                })
            },
            onConfigReady() {
                let no = this.no;
                if(no != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {value: no};
                    let fieldInfo = {};
                    fieldInfo["no"] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            //
            queryHandler(queryModel){
                //1、接收查询条件
                this.queryModel = queryModel;
                //
                this.pageNumber = 1;
                this.getRefundVoucherList();
            },
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(Vue.$getClassInfo(this).path, action, targetPostId);
            },
            showSearch: function (flag) {
                this.searchShow = flag;
            },
            // 起始时间变化事件
            fromDateChange: function (val) {
                if(!Utils.isNoB(this.toDate)) {
                    let endDate = this.toDate.format("yyyy-MM-dd");
                    if(endDate < val) {
                        MsgBox.warning("起始时间不能大于结束时间");
                        this.fromDate = null;
                    }
                }
            },
            // 结束时间变化事件
            endDateChange: function (val) {
                if(!Utils.isNoB(this.fromDate)) {
                    let startDate = this.fromDate.format("yyyy-MM-dd");
                    if(startDate > val) {
                        MsgBox.warning("结束时间不能小于起始时间");
                        this.toDate = null;
                    }
                }
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getRefundVoucherList();
            },
            //处理排序事件
            sortListData(sortInfo){
                this.sortField = sortInfo.prop;
                this.sortOrder = sortInfo.order;
                //
                this.getRefundVoucherList();
            },
            getRefundVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };

                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                let state = filterItems.refundResultState;
                if(!Utils.isNoB(state)) {
                    if(state == 'success') {
                        filterItems.auditState = 1;
                        filterItems.payResult = 1;
                    } else if(state == 'failure') {
                        filterItems.auditState = 1;
                        filterItems.payResult = -1;
                    } else if(state == 'refused') {
                        filterItems.auditState = -1;
                    }
                }
                filterItems.directFlag = getEnumInfoWith('directFlag', 'name', 'Bckward').value;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let msgBoxDlg = MsgBox.loading();
                finacApi.getVendorPayVoucherList(postData, function (result) {
                    msgBoxDlg.close();
                    if(result.type === "info") {
                        let data = result.data;
                        let refundVoucherList = data.rows;
                        if(!Utils.isNoB(refundVoucherList) && refundVoucherList.length > 0) {
                            for(let i = 0; i < refundVoucherList.length; i++) {
                                let refundVoucher = refundVoucherList[i];
                                //
                                let payWayInfo = getEnumInfoWith('payWay', 'value', refundVoucher.payWay);
                                if(payWayInfo != null) {
                                    refundVoucher.payWayText = payWayInfo.text;
                                }
                                //
                                let resultStateInfo = getEnumInfoWith('resultState', 'value', refundVoucher.payResult);
                                if(resultStateInfo != null) {
                                    if(resultStateInfo.name == "Failure") {
                                        refundVoucher.refundResultText = "退款失败";
                                    } else if(resultStateInfo.name == "Success") {
                                        if(!refundVoucher.confirmState) {
                                            refundVoucher.refundResultText = "退款成功 未确认";
                                        } else {
                                            refundVoucher.refundResultText = "退款成功";
                                        }
                                    } else {
                                        let auditStatefo = getEnumInfoWith('auditState', 'value', refundVoucher.auditState);
                                        if(!Utils.isNoB(auditStatefo) && auditStatefo.name == 'AuditFail') {
                                            refundVoucher.refundResultText = "拒绝退款";
                                        } else {
                                            refundVoucher.refundResultText = "待退款";
                                        }
                                    }
                                }
                                //
                                refundVoucher.amount = refundVoucher.amount.toFixed(2);
                                refundVoucher.yjAmount = (refundVoucher.yjAmount || 0).toFixed(2);
                                refundVoucher.paidAmount = refundVoucher.paidAmount.toFixed(2);
                            }
                        }
                        self.refundVoucherList = refundVoucherList;
                        //
                        let pagination = data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        self.renderTable(refundVoucherList, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 查看详情
            refundVoucherDetail: function (id, optFlag) {
                let self = this;
                let title = '';
                let okVisible = true;
                let cancelText = '取消';
                if(optFlag == 'chaKan') {
                    title = '退款单据 - 查看详情';
                    okVisible = false;
                    cancelText = '关闭';
                } else {
                    title = '退款单据 - 审核';
                }
                Vue.$showDialog({
                    title: title,
                    showCloseBtn: true,
                    okVisible: okVisible,
                    cancelText: cancelText,
                    width: 900,
                    height: 700,
                    template: '<div>' +
                    '<swb-refund-voucher-detail :voucherId="id" :optionFlag="optionFlag" ref="swb_refund_voucher_detail"></swb-refund-voucher-detail>' +
                    '</div>',
                    data: {
                        loading: false,
                        id: null,
                        optionFlag: optFlag
                    },
                    methods: {},
                    okClicked: function () {
                        if(optFlag == 'shenHe') {
                            let result = this.$refs.swb_refund_voucher_detail.getDlgResult() || {};
                            // 成功执行
                            if(result.type == 'info') {
                                let postData = result.data;
                                //
                                let msgBoxDlg = MsgBox.loading();
                                finacApi.auditPayVoucher(postData, function (result) {
                                    msgBoxDlg.close();
                                    if(result.type === "info") {
                                        MsgBox.success("操作成功");
                                        self.getRefundVoucherList();
                                    } else {
                                        MsgBox.warning(result.message);
                                    }
                                });
                                return true;
                            } else {
                                MsgBox.warning(result.message);
                            }
                            return false;
                        }
                    },
                    lifecycle: {
                        created: function () {
                            this.id = id;
                        }
                    }
                });
            },
            // 确认退款
            updateRefundVoucherConfirmState: function (id) {
                let self = this;
                self.$confirm('确定要确认收款吗', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    let postData = {};
                    postData.id = id;
                    //
                    let msgBoxDlg = MsgBox.loading();
                    finacApi.updatePayVoucherConfirmState(postData, function (result) {
                        msgBoxDlg.close();
                        if(result.type === "info") {
                            MsgBox.success("确认成功");
                            self.getRefundVoucherList();
                        } else {
                            MsgBox.warning('确认失败');
                        }
                    });
                }).catch(function () {
                });
            },
            // 跳转交易单列表
            goToTradeVoucherList: function (tradeNo, contractOriginalNo) {
                let type = null;
                if(Utils.isNoB(contractOriginalNo)) {
                    type = getEnumInfoWith('tradeVoucherType', 'name', 'GeneralVoucher').value;
                } else {
                    type = getEnumInfoWith('tradeVoucherType', 'name', 'ContractVoucher').value;
                }
                this.$router.push({
                    path: SwbTradeVoucherList.path,
                    query: {no: tradeNo, tradeVoucherType: type}
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/payment/RefundVoucherOfVendorList.vue